import { createRouter, createWebHistory } from 'vue-router'
import { setupLayouts } from 'virtual:generated-layouts'

import type { NavigationGuard } from 'vue-router'
import type { UserModule } from '~/types'

import generatedRoutes from '~pages'
import { getImmediateState, isOfflineDevelopment } from '~/utils'

export const matterIdMiddleware: NavigationGuard = (to) => {
  if (to.query.matterReferenceId) {
    localStorage.setItem('matterReferenceId', to.query.matterReferenceId.toString())
    to.query.matterReferenceId = null
  }

  return true
}

export const guard: NavigationGuard = (to) => {
  const { isSignedIn, isAuthorized, isMatterId } = getImmediateState(to)

  const isAuthenticated = isSignedIn || isOfflineDevelopment

  const isAllowed = isAuthorized || isOfflineDevelopment

  if (!isAuthenticated && to.meta?.requiresAuth)
    return { name: 'sign-in' }

  else if (!isAllowed && (to.meta?.requiresAuth || (to.name === 'sign-in' && isAuthenticated)))
    return { name: 'unauthorized' }

  else if (!isMatterId && (to.meta?.requiresAuth || (to.name === 'sign-in' && isAuthenticated)))
    return { name: 'no-matter-id' }

  else if (to.name === 'sign-in' && isAuthenticated)
    return { name: 'index' }

  else
    return true
}

export const install: UserModule = (app) => {
  const routes = setupLayouts(generatedRoutes)

  const router = createRouter({
    history: createWebHistory(),
    routes,
  })

  app.use(router)

  router.beforeEach(matterIdMiddleware)
  router.beforeEach(guard)

  router.isReady().then(() => app.mount('#app'))
}

export default { install }
